import { Component, Input } from '@angular/core';
import { ReportBuilderService } from '../report-builder.service';
import { SchemaObject,TableColumn } from '../openapi-schema';

@Component({
    selector: 'app-dynamic-cell',
    templateUrl: './dynamic-cell.component.html',
    styleUrls: ['./dynamic-cell.component.scss'],
    standalone: false
})
export class DynamicCellComponent {
  @Input() schema!: SchemaObject;
  @Input() value: any;
  
  childColumns: TableColumn[] = [];

  constructor(private reportService: ReportBuilderService) {}

  ngOnInit() {
    if (this.schema.properties) {
      this.childColumns = this.reportService.buildColumns(this.schema);
    } else if (this.schema.items) {
      this.childColumns = this.reportService.buildColumns(this.schema.items);
    }
  }

  getValue(data: any, path: string): any {
    return this.reportService.getValue(data, path);
  }
}
